import { createContext, useContext } from "react";

import type { WeeklyLive } from "../../hooks/useWeeklyLive.js";

/** Der Live-Raum des angezeigten Weeklies; `null` = kein Raum (abgeschlossen oder noch nicht verbunden). */
export const LiveKontext = createContext<WeeklyLive | null>(null);

export const useLive = () => useContext(LiveKontext);
